import * as React from 'react';

const SvgSocialYoutube: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.54 6.405a2.755 2.755 0 00-1.945-1.945C18.88 4 12 4 12 4s-6.88 0-8.595.46A2.755 2.755 0 001.46 6.405C1 8.12 1 11.7 1 11.7s0 3.58.46 5.295a2.755 2.755 0 001.945 1.945C5.12 19.4 12 19.4 12 19.4s6.88 0 8.595-.46a2.755 2.755 0 001.945-1.945C23 15.28 23 11.7 23 11.7s0-3.58-.46-5.295z"
        fill="currentColor"
      />
      <path d="M9.798 15l5.716-3.3-5.716-3.3V15z" fill="white" />
    </svg>
  );
};

export default SvgSocialYoutube;
